import React, {useState} from 'react';
import styled from 'styled-components';
import {useStore} from "../../utils/store";
import CircleCross from "../../assets/svg/circleCross.inline.svg";
import Image from "../atoms/Image";
import SubForm from "./SubForm";

const Holder = styled.div`
  position: fixed;
  z-index: 20;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  @media ( ${props => props.theme.breakpoints.md} ) {
    padding: 1rem;
  }
  @media ( ${props => props.theme.breakpoints.lg} ) {
    padding: 3rem;
  }
`;

const Inner = styled.div`
  background-color: ${props => props.theme.colours.grey4};
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  @media ( ${props => props.theme.breakpoints.md} ) {
    border-radius: 2rem;
    max-width: 56rem;
    position: relative;
    grid-template-rows: auto auto;
    overflow: hidden;
    padding: 3rem;
    row-gap: 2rem
  }

  h3 {
    color: ${props => props.theme.colours.green};
  }

  .submit-message {
    margin: 3rem 0;
    color: ${props => props.theme.colours.green};
    @media ( ${props => props.theme.breakpoints.md} ) {
      margin: 1rem 0;
    }
  }

  form {
    input[type="submit"] {
      margin-top: 1.5rem;
    }
  }
`;

const ColHolder = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 3rem;
`

const Col1 = styled.div``;

const Col2 = styled.div``;

const CloseHolder = styled.div`
  position: fixed;
  top: 1rem;
  right: 1rem;
  @media ( ${props => props.theme.breakpoints.md} ) {
    position: absolute;
  }

  svg {
    path, circle {
      stroke: ${props => props.theme.colours.black4};
      @media ( ${props => props.theme.breakpoints.md} ) {
        stroke: ${props => props.theme.colours.green};
      }
    }
  }
`;

const ImageHolder = styled.div`
  display: none;
  @media ( ${props => props.theme.breakpoints.md} ) {
    display: block;
    padding: 0 2rem;
  }

  img {
    width: 100%;
  }
`;

function PopupForm3() {
    const [submitMsg, setSubmitMsg] = useState(false);
    const subOpen = useStore(state => state.subOpen);
    const closeSub = useStore(state => state.closeSub);
    const setCustomSub = useStore((state) => state.setCustomSub)

    if (!subOpen) return null;
    return (
        <Holder>
            <Inner>
                <h3>Subscribe to the Fully Charged Blog to be notified of new articles.</h3>
                <ColHolder>
                    <Col1>
                        <SubForm submitMsg={submitMsg} submitMsgHandler={(message) => setSubmitMsg(message)}/>
                    </Col1>
                    <Col2>
                        <ImageHolder>
                            <Image imgName="Bus-image.png"/>
                        </ImageHolder>
                    </Col2>
                </ColHolder>
                <CloseHolder>
                    <button aria-label="Close the pop-up" onClick={() => {
                        closeSub()
                        setCustomSub(null)
                    }} className="button icon"><CircleCross/>
                    </button>
                </CloseHolder>
            </Inner>
        </Holder>
    )
}

export default PopupForm3;
